import { OnboardingWizard } from './onboarding-wizard';

export function OnboardingRoute() {
  return <OnboardingWizard />;
}
